import React from 'react';
import { instanceOf, func, string, bool } from 'prop-types';
import MapViewSettings from './MapViewSettings';
import MapIndexGroupSettings from './MapIndexGroupSettings';
import MapLabelSettings from './MapLabelSettings';
import MapIndexRangeSettings from './MapIndexRangeSettings';

const MapSettings = ({
  view,
  data,
  handleViewChange,
  mapSettings,
  runReport,
  geoLabel,
  indexLabel,
  setGeoLabel,
  setIndexLabel,
  indexRange,
  updateMapSettings,
  dropdownListTitle,
}) => {
  return (
    <div className="map--settings">
      <div className="map--settings__title">SETTINGS</div>
      <MapViewSettings
        view={view}
        data={data}
        handleViewChange={handleViewChange}
        runReport={runReport}
        dropdownListTitle={dropdownListTitle}
      />
      <MapIndexRangeSettings
        indexRange={indexRange}
        mapSettings={mapSettings}
        runReport={runReport}
        updateMapSettings={updateMapSettings}
      />
      <MapIndexGroupSettings
        data={data}
        mapSettings={mapSettings}
        runReport={runReport}
        updateMapSettings={updateMapSettings}
      />
      <MapLabelSettings
        geoLabel={geoLabel}
        indexLabel={indexLabel}
        setGeoLabel={setGeoLabel}
        setIndexLabel={setIndexLabel}
      />
    </div>
  );
};

MapSettings.propTypes = {
  data: instanceOf(Array),
  handleViewChange: func,
  view: string,
  mapSettings: instanceOf(Object),
  runReport: func,
  geoLabel: bool,
  indexLabel: bool,
  setGeoLabel: func,
  setIndexLabel: func,
  indexRange: instanceOf(Array),
  updateMapSettings: func,
};

export default MapSettings;
